'use client';
import AutoComplete from "./AutoComplete.js";
export default AutoComplete;